import type { LinkToFunc } from 'src/components/app-context';
import type { Maybe, Product } from 'src/types';

export const delayedScrollIntoView = (targetElement: HTMLElement) => {
  let timeout = 0;
  const navBarHeight = 71;
  const header = window.document.getElementsByTagName('header')?.[0];
  const offset = (header?.getBoundingClientRect().height ?? 0) + navBarHeight;
  const sizeObserver = new ResizeObserver(() => {
    clearTimeout(timeout);
    _scrollTo(targetElement, offset);
    timeout = window?.setTimeout(() => {
      _scrollTo(targetElement, offset);
      sizeObserver.disconnect();
    }, 500);
  });

  sizeObserver.observe(window.document.body);
};

function _scrollTo(targetElement: HTMLElement, yOffset: number) {
  const y =
    (targetElement?.getBoundingClientRect().top || 0) +
    window.scrollY -
    yOffset;

  window.scrollTo({ top: y });
}

export const getSimilarProductsCompareLink = (
  similarProducts: Maybe<{ recommendations?: Maybe<any[]> }> | undefined,
  product: Product,
  linkTo: LinkToFunc
) => {
  if (!similarProducts?.recommendations?.length) return null;

  const products = similarProducts.recommendations
    .filter(item => item.product)
    .map(item => item.product);

  return products.length
    ? linkTo('productCompare', {
        category: product.category,
        products: product ? [product, ...products] : products,
      })
    : null;
};
